import { SUPPLIERS_FETCH_SUPPLIERS } from '../action-types/suppliers-types';

const initialState = {
  entities: [],
  entity: {},
  entityLoaded: false,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SUPPLIERS_FETCH_SUPPLIERS.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SUPPLIERS_FETCH_SUPPLIERS.SUCCESS:
      return {
        ...state,
        entities: [...action.payload.data.manufacturers],
        loading: false,
      };
    case SUPPLIERS_FETCH_SUPPLIERS.REJECTED:
      return {
        ...state,
        loading: false,
        entities: [],
      };
    default:
      return state;
  }
}
